module.exports = __webpack_public_path__ + "img/ps_IOS.3efad61a.png";